import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employerDetails: {
    employerName: "Default Name",
    employerId: null,
    molId: null,
  },
};

const employerSlice = createSlice({
  name: "employer",
  initialState,
  reducers: {
    setEmployerDetails: (state, action) => {
      state.employerDetails = action.payload;
    },
    clearEmployerDetails: (state) => {
      state.employerDetails = initialState.employerDetails;
    },
  },
});

export const { setEmployerDetails, clearEmployerDetails } =
  employerSlice.actions;
export const employerReducer = employerSlice.reducer;
export default employerSlice;
